import { render, staticRenderFns } from "./Dashboard-Visits.vue?vue&type=template&id=09830d0e"
import script from "./Dashboard-Visits.vue?vue&type=script&lang=js"
export * from "./Dashboard-Visits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports